export const APIs = {
  common: {
    setting_info: () => ({
      method: "GET",
      url: `/site-setting/info`,
    }),
    authentication: () => ({
      method: "GET",
      url: `/site-setting/authentication`,
    }),
  },
  auth_user: {
    check_user_id: (data) => ({
      method: "POST",
      url: "/user-key/check-exists",
      data,
    }),
    check_email: (data) => ({
      method: "POST",
      url: "/user-key/check",
      data,
    }),
    confirm_email: (data) => ({
      method: "POST",
      url: "/user-key/confirm",
      data,
    }),
    sign_up: (data) => ({
      method: "POST",
      url: "/user/signup",
      data,
    }),
    sign_in: (data) => ({
      method: "POST",
      url: `/user/signin`,
      data,
    }),
    refresh_token: (data) => ({
      method: "POST",
      url: "/user/signin-by-refresh-token",
      data,
    }),
    find_id: (data) => ({
      method: "POST",
      url: "/user/find-id",
      data,
    }),
    find_password_by_email: (data) => ({
      method: "POST",
      url: "/user/reset-password-token",
      data,
    }),
    reset_password_by_token: (data) => ({
      method: "POST",
      url: "/user/reset-password",
      data,
    }),
  },
  user: {
    view: (userId) => ({
      method: "GET",
      url: `/user/${userId}`,
    }),
    update_info: (userId, data) => ({
      method: "PATCH",
      url: `/user/${userId}`,
      data,
    }),
    remove_email: (userId, data) => ({
      method: "POST",
      url: `/user/delete-user-key/${userId}/Email`,
      data,
    }),
    change_email: (userId, data) => ({
      method: "POST",
      url: `/user/change-user-key/${userId}`,
      data,
    }),
    change_password: (userId, data) => ({
      method: "POST",
      url: `/user/change-password/${userId}`,
      data,
    }),
    withdraw: (data) => ({
      method: "POST",
      url: "/user/retire",
      data,
    }),
  },
  board_item: {
    list: (queryStr) => ({
      method: "GET",
      url: `/board-item?${queryStr}`,
    }),
    search: (queryStr, data) => ({
      method: "POST",
      url: `/board-item/search?${queryStr}`,
      data,
    }),
    create: (boardCode, data) => ({
      method: "PUT",
      url: `/board-item/${boardCode}`,
      data,
    }),
    detail: (boardCode, itemNo, queryStr) => ({
      method: "GET",
      url: `/board-item/${boardCode}/${itemNo}${queryStr}`,
    }),
    update: (boardCode, itemNo, data) => ({
      method: "PATCH",
      url: `/board-item/${boardCode}/${itemNo}`,
      data,
    }),
    delete: (boardCode, itemNo) => ({
      method: "DELETE",
      url: `/board-item/${boardCode}/${itemNo}`,
    }),
    download_as_excel: (boardCode) => ({
      method: "GET",
      url: `/board-item/download-data/${boardCode}`,
    }),
    verify_password_view: (boardCode, itemNo, data) => ({
      method: "POST",
      url: `/board-item/${boardCode}/${itemNo}/verify-writer-password`,
      data,
    }),
    verify_password_edit: (boardCode, itemNo, data) => ({
      method: "POST",
      url: `/board-item/${boardCode}/${itemNo}/verify-edit-access`,
      data,
    }),
  },
  comment: {
    create: (boardCode, itemNo, data) => ({
      method: "PUT",
      url: `/board-item-comment/${boardCode}/${itemNo}`,
      data,
    }),
    update: (boardCode, itemNo, commentNo, data) => ({
      method: "PATCH",
      url: `/board-item-comment/${boardCode}/${itemNo}/${commentNo}`,
      data,
    }),
    delete: (boardCode, itemNo, commentNo) => ({
      method: "DELETE",
      url: `/board-item-comment/${boardCode}/${itemNo}/${commentNo}`,
    }),
    list: (boardCode, itemNo, queryStr) => ({
      method: "GET",
      url: `/board-item-comment?BoardCode=${boardCode}&itemNo=${itemNo}&${queryStr}`,
    }),
    verify_password_view: (boardCode, itemNo, commentNo, data) => ({
      method: "POST",
      url: `/board-item-comment/${boardCode}/${itemNo}/${commentNo}/verify-password`,
      data,
    }),
    verify_password_edit: (boardCode, itemNo, commentNo, data) => ({
      method: "POST",
      url: `/board-item-comment/${boardCode}/${itemNo}/${commentNo}/verify-edit`,
      data,
    }),
  },
  file: {
    get_upload_url: (boardCode, isComment) => ({
      method: "GET",
      url: `/board-item-file/${boardCode}/upload-url${
        isComment ? "?isComment=true" : ""
      }`,
    }),
  },
  captcha: {
    get_id: () => ({
      method: "GET",
      url: "/site-common/captcha/generate",
    }),
    get_text: (captchaId) => ({
      method: "GET",
      url: `/site-common/captcha/${captchaId}`,
    }),
    verify: (data) => ({
      method: "POST",
      url: "/site-common/captcha/verify",
      data,
    }),
  },
  board: {
    detail: (boardCode) => ({
      method: "GET",
      url: `/board/${boardCode}`,
    }),
    list: () => ({
      method: "GET",
      url: `/board`,
    }),
  },
};
